import { ReactNode } from 'react';
import { ExtendButtonBase, IconButtonTypeMap } from '@mui/material';

import { EXPORT_STATUS } from '../../types';
import { ColourType } from '../Button/Button.styles';

export interface ExportButtonWithDialogProps {
	total: number;
	requestParams: Record<string, string>;
	disabled?: boolean;
	source: string;
	title?: string;
	// eslint-disable-next-line @typescript-eslint/ban-types
	iconProps?: ExtendButtonBase<IconButtonTypeMap<{}, 'button'>>;
	maxRows?: number;
	dialogDataCy?: string;
	iconDataCy?: string;
	dataCy?: string;
	maxPollAttempts?: number;
	iterationTime?: number;
	messages?: Partial<Record<EXPORT_STATUS, string | ReactNode>>;
	variant?: 'contained' | 'outlined' | 'text';
	color?: ColourType;
}
